import { TireHotelDetailTab } from './adminRouteParams';
import { defineRoutes } from './types';
import { getUrlWithQueryParams } from './utils';

// Define the parameters for the routes
interface PathConfig {
  printLabelForStorageObject: { identifier: string };
  inventoryTireOrder: { id: string };
  inventoryTireOrderMount: { id: string };
  storageObjectEvent: { id: number | string };
  printWheelSetsLabels: { search?: string };
  ticketDetail: { id: number | string; tab?: 'details' | 'activity' };
  emailDetail: { id: number | string };
  tireHotelDetail: { id: number | string; tab?: TireHotelDetailTab };
  garagePickingListDetail: { identifier: string; 'from-date'?: string; 'to-date'?: string };
}

export const facilityRoutes = defineRoutes<PathConfig>()({
  notifications: {
    getPath: () => '/notifications',
    getBasePath: () => '/notifications'
  },
  storageObjectEvent: {
    getPath: (data) => `/storage-object-events/${data.id}`,
    getBasePath: () => '/storage-object-events/:id'
  },
  login: {
    getPath: () => '/login',
    getBasePath: () => '/login'
  },
  resetPassword: {
    getPath: () => '/reset-password',
    getBasePath: () => '/reset-password'
  },
  profile: {
    getPath: () => '/profile',
    getBasePath: () => '/profile'
  },
  home: {
    getPath: () => '/',
    getBasePath: () => '/'
  },
  garagePickingListDetail: {
    getPath: ({ identifier, ...rest }) =>
      getUrlWithQueryParams({
        path: `/garage-picking-list/${identifier}`,
        queryParams: rest
      }),
    getBasePath: () => '/garage-picking-list/:identifier'
  },
  inventoryCarWheelSets: {
    getPath: () => '/inventory/car-wheel-sets',
    getBasePath: () => '/inventory/car-wheel-sets'
  },
  routePreparation: {
    getPath: () => '/staff-preparation',
    getBasePath: () => '/staff-preparation'
  },
  printWheelSetsLabels: {
    getPath: (queryParams) =>
      getUrlWithQueryParams({
        path: `/print-wheel-sets-labels`,
        queryParams
      }),
    getBasePath: () => '/print-wheel-sets-labels'
  },
  inventoryTireOrders: {
    getPath: () => '/inventory/tire-orders',
    getBasePath: () => '/inventory/tire-orders'
  },
  inventoryTireOrder: {
    getPath: (data) => `/inventory/tire-orders/${data.id}`,
    getBasePath: () => '/inventory/tire-orders/:id'
  },
  inventoryTireOrderMount: {
    getPath: (data) => `/inventory/tire-orders/${data.id}/mount`,
    getBasePath: () => '/inventory/tire-orders/:id/mount'
  },
  printList: {
    getPath: () => '/print-list',
    getBasePath: () => '/print-list'
  },
  printForStoredTires: {
    getPath: () => '/print-for-stored-tires',
    getBasePath: () => '/print-for-stored-tires'
  },
  printWorkOrders: {
    getPath: () => '/print-work-orders',
    getBasePath: () => '/print-work-orders'
  },
  tiresAtFacility: {
    getPath: () => '/tires-at-facility',
    getBasePath: () => '/tires-at-facility'
  },
  tickets: {
    getPath: () => '/tickets',
    getBasePath: () => '/tickets'
  },
  ticketDetail: {
    getPath: ({ id, ...rest }) => getUrlWithQueryParams({ path: `/tickets/${id}`, queryParams: rest }),
    getBasePath: () => '/tickets/:id'
  },
  emailDetail: {
    getPath: (data) => `/communications/emails/${data.id}`,
    getBasePath: () => '/communications/emails/:id'
  },
  devSettings: {
    getPath: () => `/dev-settings`,
    getBasePath: () => '/dev-settings'
  },
  tireHotels: {
    getPath: () => '/tire-hotels',
    getBasePath: () => '/tire-hotels'
  },
  tireHotelDetail: {
    getPath: ({ id, ...rest }) =>
      getUrlWithQueryParams({
        path: `/tire-hotels/${id}`,
        queryParams: rest
      }),
    getBasePath: () => '/tire-hotels/:id'
  }
});
